export const targetEmail = "https://formsubmit.co/ajax/52973de8e7a713b9a94c1d5b553b05b6"